"use client";

import { ModuleSection } from "./ModuleSection";
import { useI18n } from "@/lib/i18n/I18nProvider";
import { TreasuryVisual, KpiVisual, UsaliVisual, ProcurementVisual, AiVisual } from "./ModuleVisuals";

export function ModulesShowcase() {
  const { t } = useI18n();

  const MODULES = [
    {
      title: t("landing.modules.treasury.title"),
      description: t("landing.modules.treasury.desc"),
      bullets: [
        t("landing.modules.treasury.b1"),
        t("landing.modules.treasury.b2"),
        t("landing.modules.treasury.b3"),
        t("landing.modules.treasury.b4"),
      ],
      reversed: false,
    },
    {
      title: t("landing.modules.kpi.title"),
      description: t("landing.modules.kpi.desc"),
      bullets: [
        t("landing.modules.kpi.b1"),
        t("landing.modules.kpi.b2"),
        t("landing.modules.kpi.b3"),
        t("landing.modules.kpi.b4"),
      ],
      reversed: true,
    },
    {
      title: t("landing.modules.usali.title"),
      description: t("landing.modules.usali.desc"),
      bullets: [
        t("landing.modules.usali.b1"),
        t("landing.modules.usali.b2"),
        t("landing.modules.usali.b3"),
        t("landing.modules.usali.b4"),
      ],
      reversed: false,
    },
    {
      title: t("landing.modules.procurement.title"),
      description: t("landing.modules.procurement.desc"),
      bullets: [
        t("landing.modules.procurement.b1"),
        t("landing.modules.procurement.b2"),
        t("landing.modules.procurement.b3"),
        t("landing.modules.procurement.b4"),
      ],
      reversed: true,
    },
    {
      title: t("landing.modules.ai.title"),
      description: t("landing.modules.ai.desc"),
      bullets: [
        t("landing.modules.ai.b1"),
        t("landing.modules.ai.b2"),
        t("landing.modules.ai.b3"),
        t("landing.modules.ai.b4"),
      ],
      reversed: false,
    },
  ];

  const VISUALS: React.ReactNode[] = [
    <TreasuryVisual key="tv" />,
    <KpiVisual key="kv" />,
    <UsaliVisual key="uv" />,
    <ProcurementVisual key="pv" />,
    <AiVisual key="av" />,
  ];

  return (
    <div id="features">
      {MODULES.map((module, index) => (
        <section
          key={index}
          className={index % 2 === 1 ? "bg-slate-50/50" : "bg-white"}
        >
          <ModuleSection
            title={module.title}
            description={module.description}
            bullets={module.bullets}
            visual={VISUALS[index]}
            reversed={module.reversed}
          />
        </section>
      ))}

      {/* CTA after modules */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-5xl mx-auto text-center">
          <a
            href="#demo"
            className="inline-flex items-center gap-2 bg-keiro-green hover:bg-keiro-green-dark text-white px-6 py-3 text-base font-semibold rounded-lg transition-colors"
          >
            {t("landing.cta.requestDemo")}
          </a>
        </div>
      </section>
    </div>
  );
}
